import { render, staticRenderFns } from "./ReturnItems.vue?vue&type=template&id=dffd9dea&"
import script from "./ReturnItems.vue?vue&type=script&lang=js&"
export * from "./ReturnItems.vue?vue&type=script&lang=js&"
import style0 from "./ReturnItems.vue?vue&type=style&index=0&id=dffd9dea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports